import { LazyLoad } from 'app/utils';

export const InfoSortPage = LazyLoad(() => import('./index'), (module) => module.InfoSortPage);
